<template>
<v-container fluid class="pa-4 server-container">
  <v-form ref="form">
    <TextField 
      :loading="any_loading"
      :label="`${$t('Адрес привязки локального сервера.')} ${$t('Не изменяйте значение без необходимости')} (${$t('Требуется перезапуск')})`"
      :hint="$t('По-умолчанию 0.0.0.0 - прослушивать все доступные адреса')"
      :rules="[rules.ipaddrzeroes]"
      :original_value="config.host || '0.0.0.0'"
      :value="local_config.host || '0.0.0.0'"
      @input="e => local_config.host = e"
    />

    <TextField 
      :loading="any_loading"
      :label="`${$t('Порт привязки локального сервера. По-умолчанию: 11222')} (${$t('Требуется перезапуск')})`"
      :hint="$t('Указанный порт будет занят локальным сервером модуля доставки')"
      :rules="[rules.port]"
      type="number"

      :original_value="config.port"
      v-model="local_config.port"
    />

    <TextField 
      :loading="any_loading"
      :label="`${$t('Количество потоков локального сервера')} (${$t('Требуется перезапуск')})`"
      :hint="`${$t('Расчитайте количество потоков по формуле 2N+2, где N - количество компьютеров, на которых планируется работа с UI модуля доставки.')}\n${$t('По-умолчанию - 4, из расчета на одну кассовую станцию')}`"
      :rules="[rules.inrange(4, 64)]"
      type="number"

      :original_value="config.threads"
      v-model="local_config.threads"
    />

    <SelectField 
      :loading="any_loading"
      :label="`${$t('Язык интерфейса')}`"
      :hint="$t('Интерфейс модуля доставки будет переведен на выбранный язык')"
      :rules="[rules.require]"
      :items="locales"

      :original_value="config.locale"
      v-model="local_config.locale"
    />
  </v-form>
</v-container>
</template>

<script>
import TextField from '../../common/TextField.vue'
import settings_group_mixin from '../settings_group_mixin'
import SelectField from '../../common/SelectField.vue'

export default {
  mixins: [settings_group_mixin],
  data: () => ({
    local_loading: false,
    locales: [],

  }),
  computed: {
    any_loading() {
      return this.local_loading || this.local_loading
    }
  },
  methods: {
    async loadLocales(){
      this.local_loading = true
      try {
        this.locales = await this.$store.dispatch('getAvailableLocales')
      } finally {
        this.local_loading = false
      }
    },
    validate(){
      if (!this.$refs.form.validate()) {
        throw new Error(this.$t('Проверьте корректность веденных настроек перед сохранением изменений'))
      }
    }
  },
  mounted(){
    this.loadLocales()
  },
  components: {
    TextField,
    SelectField
  }
}
</script>
<style>
.server-container .v-input {
  margin-bottom: 0px !important;
}
</style>